export default "__VITE_ASSET__CzkHsYUg__"